import classNames from 'classnames'
import React, { useState } from 'react'
import { TermsList } from '../../../../constants/variables'
import moment from 'moment/moment'
import { downloadTermPDF } from '../../../../api/drivers'
import DownloadIcon from '@mui/icons-material/Download';
import { CircularProgress } from '@mui/material'

function Terms({ driver, title, fields }) {
    const [loadingIds, setLoadingIds] = useState([]); // store all active termIds

    async function exportTermPdf(event, termId, date) {
        event.preventDefault();
        event.stopPropagation();
        if (termId && date) {
            const id = termId._id;

            // Add to active loaders
            setLoadingIds((prev) => [...prev, id]);

            const fileName = `${driver.firstName}_${driver.lastName}_${termId.type}`;
            try {
                await downloadTermPDF({
                    termId: id,
                    date,
                    userId: driver._id,
                    fileName,
                });
            } catch (err) {
                console.error("Download failed:", err);
            } finally {
                // Remove from active loaders
                setLoadingIds((prev) => prev.filter((t) => t !== id));
            }
        }
    }

    return (
        <div className="form__col form__col_height-flex">
            <div className="section">
                <h3 className={classNames("section__title", { section__title_long: false })}>
                    {title}:
                </h3>
                <ul className="brief brief_terms">
                    {fields.map((val) => {
                        const isLoading = loadingIds.includes(val.termId?._id);

                        return (
                            val.termId?._id ?
                            (<li
                                key={val.termId._id}
                                className="brief__item_terms"
                                style={{ display: "flex", flexDirection: "column", alignItems: "end" }}
                            >
                                <span
                                    className="brief__item-cell brief__item-cell_title"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) =>
                                        !isLoading &&
                                        exportTermPdf(e, val.termId, moment(val.date).format("YYYY-MM-DD"))
                                    }
                                >
                                    {TermsList[val.termId.type]}{" "}
                                    {isLoading ? (
                                        <CircularProgress size={18} sx={{ color: "#4195f5" }} />
                                    ) : (
                                        <DownloadIcon style={{ width: "20px", height: "20px" }} />
                                    )}
                                </span>
                                <span className="brief__item-cell brief__item-cell_value">
                                    {moment(val.date).format("LLL")}
                                </span>
                            </li>) : ''
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}

export default Terms